import { ChangeDetectionStrategy, Component, Inject, ViewChild } from "@angular/core";
import { Organisation } from "@common/ADAPT.Common.Model/organisation/organisation";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { ErrorHandlingUtilities } from "@common/lib/utilities/error-handling-utilities";
import { ProgressService } from "@common/progress/progress.service";
import { ADAPT_DIALOG_DATA } from "@common/ux/adapt-common-dialog/adapt-common-dialog.globals";
import { BaseDialogComponent, DialogResolveData } from "@common/ux/adapt-common-dialog/base-dialog.component/base-dialog.component";
import { catchError, EMPTY, tap } from "rxjs";
import { SelectProgressProductsComponent } from "../select-progress-products/select-progress-products.component";

export interface IImportProgressProductsDialogData {
    organisation?: Organisation;
    organisations?: Organisation[];
}

@Component({
    selector: "adapt-import-progress-products-dialog",
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "./import-progress-products-dialog.component.html",
})
export class ImportProgressProductsDialogComponent extends BaseDialogComponent<IImportProgressProductsDialogData, void> {
    public readonly dialogName = "ImportProgressProducts";

    public readonly fixedOrganisation: boolean;
    public readonly organisations: Organisation[];
    public organisation?: Organisation;
    public productsToAdd: number[] = [];

    @ViewChild(SelectProgressProductsComponent, { static: true }) private progressProductSelect?: SelectProgressProductsComponent;

    public constructor(
        @Inject(ADAPT_DIALOG_DATA) data: IImportProgressProductsDialogData,
        private progressService: ProgressService,
    ) {
        super(DialogResolveData.NotRequired);
        this.organisation = data.organisation;
        this.fixedOrganisation = !!data.organisation;
        this.organisations = data.organisations ?? [];
    }

    public get saveIsDisabled() {
        const selector = this.progressProductSelect;
        return !this.organisation
            || this.productsToAdd.length === 0
            || !selector
            || selector.existingProducts.length > 0
            || selector.isLoading
            || !!selector.errorMessage;
    }

    @Autobind
    public saveAndClose() {
        if (!this.organisation) {
            return EMPTY;
        }

        return this.progressService.importProgressProducts(this.productsToAdd, this.organisation).pipe(
            tap(() => this.resolve()),
            catchError((err) => {
                this.setErrorMessage(ErrorHandlingUtilities.getHttpResponseMessage(err));
                return EMPTY;
            }),
        );
    }
}
